<template>
  <sea-page title="Lista cedolini" header="Elenco buste paga">
    <sea-page-content
      :fetchList="fetchList"
      :resetList="resetList"
      searchPanel
      searchType="mese"
    >
      <template v-slot:table="{ attrs }">
        <v-data-table
          v-bind="attrs"
          :items="items"
          :headers="headers"
          disable-sort
          dense
          height="calc(100vh - 255px)"
        >
          <template v-slot:item.mese="{ item }">
            {{ mesi[item.mese - 1] }}
          </template>
          <template v-slot:item.netto="{ item }">
            {{ item.netto | currencyFormat }}
          </template>
          <template v-slot:item.statoLettura="{ item }">
            <stato-lettura :stato="item.statoLettura"></stato-lettura>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn
              elevation="2"
              rounded
              x-small
              @click="editItem(item)"
              color="primary"
              class="mr-2"
            >
              Dettaglio
              <v-icon right dark>mdi-cloud-download </v-icon>
            </v-btn>
            <v-btn
              elevation="2"
              rounded
              x-small
              @click="download(item)"
              color="primary"
            >
              Apri
              <v-icon right dark>mdi-cloud-download </v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </template>
    </sea-page-content>
  </sea-page>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { mesi } from "@/constants";
import StatoLettura from "@/components/StatoLettura.vue";

const headers = [
  { text: "Mese", value: "mese", class: "head" },
  { text: "Anno", value: "anno", class: "head" },
  { text: "Descrizione", value: "descrizione", class: "head" },
  { text: "Netto", value: "netto", class: "head" },
  { text: "Letto", value: "statoLettura", class: "head" },
  { text: "", value: "actions", class: "head", cellClass: "text-end" },
];

export default {
  components: { StatoLettura },
  data() {
    return {
      headers,
      mesi,
    };
  },
  methods: {
    ...mapActions({
      fetchList: "payroll/fetchPayrolls",
      resetList: "payroll/resetPayrolls",
      download: "payroll/downloadPayroll",
    }),
    editItem(item) {
      this.$router.push({ name: "payrollDetail", params: { id: item.id } });
    },
  },
  computed: {
    ...mapGetters({
      items: "payroll/payrolls",
    }),
  },
};
</script>

<style></style>
